import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "textContainer" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "anchor-bottom" };
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useQuizApi } from '@/composables/useQuizApi';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChristmasQuizCompleteCorrectPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getQuestionnaireByGuidOrKey } = useQuizApi();
        const explainerText = ref(null);
        function onLoad() {
            getQuestionnaireByGuidOrKey(route.params.id, () => {
                console.log('Loaded questionnaire ', state.questionnaire);
                explainerText.value = state.questionnaire.questionnaireQuestions[0].question.explainer;
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(HeaderBlock, { title: "Christmas Quiz Complete" }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "title" }, "Correct!", -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "paragraph" }, " Well done you ", -1)),
                    (_unref(state).questionnaire)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(explainerText.value), 1))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(MGButton, {
                            "c:arrow": "true",
                            onClick: _cache[0] || (_cache[0] = ($event) => (_unref(router).push('/'))),
                            text: "Done"
                        })
                    ])
                ])
            ]));
        };
    }
});
